import * as React from "react";
import {Navigate, Route} from "react-router-dom";
import {has, isFunction, isPlainObject} from "lodash";
import {RouteDef, RoutesDef} from "../hooks/useRoutes";

const recursiveRouteGenerator = (
  element: RouteDef,
  path: string,
  routesInBaseElement: any[] = [],
): React.Component[] => {
  if (isPlainObject(element)) {
    routesInBaseElement.concat(
      Object.entries(element).map(([key, element]) => {
        if (!element) return;

        if (isPlainObject(element) && has(element, 'component')) {
          let routeToGenerate = (
            <Navigate to="/" />
          );

          if (!has(element, 'enabled') || element.enabled) {
            routeToGenerate = (
              <Route path={path + key} element={React.createElement(element.component)} key={path + key} />
            )
          }

          routesInBaseElement.push(routeToGenerate);

          return;
        }

        return recursiveRouteGenerator(element, path + key, routesInBaseElement);
      })
    );
  } else if (isFunction(element)) {
    // React component, return route
    routesInBaseElement.push(<Route path={path} element={React.createElement(element)} key={path} />);
  } else {
    throw new Error(`Unknown element type (${typeof element}) for path ${path}`);
  }

  return routesInBaseElement;
};

const generateRoutes = (routeConfig: RoutesDef): React.ReactElement[] => {
  return Object.entries(routeConfig).reduce((mem, [key, element]) => {
    const routes = recursiveRouteGenerator(element, key, []);

    return mem.concat(routes);
  }, []);
};

export function isArticle(path: string): boolean {
  const id = path.slice(path.length - 8);
  const idRegex = new RegExp(/-[a-z,0-9]{7}/g);

  return idRegex.test(id);
}

export default generateRoutes;
